import { motion } from "framer-motion";
import { useLang } from "../../context/LanguageContext";
import { VeroButton } from "./VeroButton";
import { Parallax, MaskReveal } from "./Media";
import { IMAGES } from "../../constants/images";

const fade = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 1, ease: [0.22, 1, 0.36, 1] },
};

export const DiptychSection = () => {
  const { t, lang } = useLang();
  return (
    <section className="px-6 md:px-14 py-16 md:py-24" data-testid="diptych-section">
      <div className="grid md:grid-cols-12 gap-10 md:gap-16">
        <div className="hidden md:block md:col-span-5">
          <div className="sticky top-24">
            <MaskReveal src={IMAGES.instructor_podium} className="h-[82vh]" />
          </div>
        </div>

        <div className="md:col-span-7 space-y-20 md:space-y-28">
          <div className="grid grid-cols-2 gap-6 md:gap-10 items-start">
            <Parallax src={IMAGES.gallery_hands} range={45} className="h-[260px] md:h-[340px]" />
            <Parallax src={IMAGES.gallery_shoes} range={70} className="h-[340px] md:h-[460px] mt-10" />
          </div>

          <motion.div {...fade}>
            <p className="font-serif text-3xl md:text-5xl leading-tight text-white max-w-2xl">{t.diptych.title}</p>
            <div className="mt-10 max-w-xl">
              <p className="font-serif italic text-lg md:text-xl text-zinc-300 leading-relaxed">{t.diptych.lead}</p>
              <p className="mt-6 text-base md:text-lg text-zinc-400 font-light leading-relaxed">{t.diptych.body}</p>
            </div>
          </motion.div>

          <MaskReveal src={IMAGES.class_energy} className="h-[300px] md:h-[480px]" />

          <motion.div {...fade}>
            <VeroButton text={t.diptych.cta} to="/book" testId="diptych-cta-btn" />
          </motion.div>

          <div className="grid grid-cols-2 gap-6 md:gap-10 items-start">
            <Parallax src={IMAGES.gallery_lights} range={55} className="h-[300px] md:h-[420px]" />
            <Parallax src={IMAGES.founder_portrait} range={40} className="h-[240px] md:h-[320px] mt-14" />
          </div>

          <motion.div {...fade}>
            <p className="font-serif text-2xl md:text-4xl leading-snug text-white max-w-2xl">{t.diptych.founderQuote}</p>
            <div className="mt-8">
              <p className="text-[0.7rem] uppercase tracking-[0.35em] text-[#C5A059]">{t.diptych.founderName}</p>
              <p className="mt-1 text-[0.7rem] uppercase tracking-[0.3em] text-zinc-500">
                <em className="font-serif italic normal-case text-[1.3em] tracking-normal">{t.diptych.founderRoleItalic}</em>{" "}
                APEX
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
